var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.494 4.55988C11.8204 10.9247 6.78041 15.8975 0.393208 17.4879C-0.128392 17.6159 -0.131592 18.3679 0.386808 18.5023C6.75161 20.1791 11.7244 25.2159 13.3148 31.6063C13.4428 32.1279 14.1948 32.1311 14.3292 31.6127C16.006 25.2447 21.0428 20.2751 27.4332 18.6847C27.9548 18.5567 27.958 17.8047 27.4396 17.6703C21.0748 15.9935 16.102 10.9567 14.5116 4.56948C14.3836 4.04788 13.6316 4.04468 13.4972 4.56308L13.494 4.55988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.fc480a226d32169e76ce5cbef57cc798.svg";
export { ForwardRef as ReactComponent };